module.exports = __webpack_public_path__ + "static/media/smacking.44cc52bb.mp4";